module.exports = __webpack_public_path__ + "img/game1.3.7302b354.png";